import React, { useState } from "react";
import PropTypes from "prop-types";
import Box from "@mui/material/Box";
import DynamicTab from "./DynamicTab/DynamicTab";
import DynamicTabCreateModal from "./DynamicTabCreateModal/DynamicTabCreateModal";
import DeleteModal from "../../Modals/DeleteModal/DeleteModal";

export default function DynamicTabPanel({
  isLoading,
  tabLabels,
  value,
  nameKey,
  handleTabChange,
  handleTabCreate,
  handleTabDelete,
  maxTabs
}) {
  const [createTabModalOpen, setCreateTabModalOpen] = useState(false);
  const [deleteTabModalOpen, setDeleteTabModalOpen] = useState(false);
  const [indexToDelete, setIndexToDelete] = useState(0);

  return (
    <Box sx={{ display: "flex", alignItems: "center" }}>
      {tabLabels.map((tab, i) => (
        <DynamicTab
          key={i}
          index={i}
          tabData={tab}
          nameKey={nameKey}
          isActive={i === value}
          handleTabChange={handleTabChange}
          deleteTabModalOpen={deleteTabModalOpen}
          setDeleteTabModalOpen={setDeleteTabModalOpen}
          setIndexToDelete={setIndexToDelete}
        />
      ))}
      {tabLabels.length < maxTabs &&
        <DynamicTabCreateModal
          handleTabCreate={handleTabCreate}
          open={createTabModalOpen}
          setOpen={setCreateTabModalOpen}
          isLoading={isLoading}
        />
      }
      <DeleteModal
        handleDelete={() => {
          handleTabDelete(indexToDelete);
          setDeleteTabModalOpen(false);
        }}
        isLoading={isLoading}
        open={deleteTabModalOpen}
        setOpen={setDeleteTabModalOpen}
        disableIcon
      />
    </Box>
  );
}

DynamicTabPanel.propTypes = {
  isLoading: PropTypes.bool.isRequired,
  tabLabels: PropTypes.array.isRequired,
  value: PropTypes.number,
  nameKey: PropTypes.string.isRequired,
  handleTabChange: PropTypes.func.isRequired,
  handleTabCreate: PropTypes.func.isRequired,
  handleTabDelete: PropTypes.func.isRequired,
  maxTabs: PropTypes.number
};